import { useState } from 'react';
import axios from 'axios';
import { useAuth } from '../../context/Auth';

const useAPI = () => {
    const [statusCode, setStatusCode] = useState();
    const auth = useAuth();

    const makeRequest = async (
        axiosRequestData,
        additionalData,
        { skipAuthError = false } = {}
    ) => {
        const requestData = attachAuthorizationHeader(axiosRequestData);
        try {
            const response = await axios({ ...requestData, ...additionalData });
            setStatusCode(response?.statusCode);
            if (isSuccessResponse) {
                const responseData = response.data;
                return responseData;
            }
        } catch (err) {
            if (err.code === 'ERR_CANCELED') {
                throw err;
            }

            if (
                auth.isTokenExpired() ||
                (err?.response?.status === 401 && !skipAuthError)
            ) {
                await auth.refreshToken();
                return makeRequest(requestData, additionalData, {
                    skipAuthError: true,
                });
            }

            throw err;
        }
    };

    const attachAuthorizationHeader = (requestData) => {
        const authHeader = auth.getAuthToken();
        if (authHeader) {
            requestData.headers = requestData.headers || {};
            requestData.headers['Authorization'] = authHeader;
        }
        return requestData;
    };

    const isSuccessResponse = (response) => {
        const hasResponseSuccess = isSuccessStatusCode(statusCode);
        try {
            const responseData = response.data;
            const responseDataStatusCode = responseData.statusCode;
            return (
                hasResponseSuccess &&
                isSuccessStatusCode(responseDataStatusCode)
            );
        } catch (err) {
            // If there is no data in response,
            // then check only response status code
            return hasResponseSuccess;
        }
    };

    const isSuccessStatusCode = (statusCode) => {
        return statusCode && statusCode >= 200 && statusCode < 300;
    };

    return { makeRequest };
};

export default useAPI;
